<template>
    <span>
        <editarlembretemedicacao></editarlembretemedicacao>
    </span>
</template>

<script>
import Editarlembretemedicacao from '@/components/Editar-Lembrete-Medicacao';

export default {
    name: 'cadeditarlembretemedicacao',
    components: {
        Editarlembretemedicacao
    }
};
</script>